import { CancelRounded } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../../../../language/keys';
import { ProgressBar } from '../../ProgressBar';
import { MatchFlowStatusEnum } from '../../../../../../consts/enums';
import { style } from './style';

export interface RunStatusNoResultsProps {
  status: string;
  duplicateCandidatesSkipped: number | undefined;
}

export const RunStatusNoResults = ({ status, duplicateCandidatesSkipped }: RunStatusNoResultsProps):JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Box>
      <ProgressBar
        value={ 100 }
        color={ status === MatchFlowStatusEnum.Degraded ? '#F1C40F' : '#ffdfa6'  }
      />
      <Box sx={ style.box.sx }>
        <CancelRounded />
        <div style={ style.textContainer }>
          <Typography variant="overline" sx={ style.typographyStatus.sx }>
            {translate(status === MatchFlowStatusEnum.Completed ? STRING_KEYS.COMPLETED : STRING_KEYS.DEGRADED)}
            : {translate(STRING_KEYS.NO_RESULTS_FOR_THIS_RUN)}
          </Typography>
          {duplicateCandidatesSkipped !== undefined && (
            <Typography variant="caption" sx={ style.typographyStatus.sx }>
              {translate(STRING_KEYS.DUPLICATE_CANDIDATES)}
              : {duplicateCandidatesSkipped}
            </Typography>
          )}
        </div>
      </Box>
    </Box>
  );
};
